<template>
    <div>
        <label>{{ $t('timetableview.label') }}</label><br/>
        <!-- <vSelect :options="timetableViewOptions" v-model="selected"  @input="select" :reduce="label => label.code" /> -->
        <vSelect :options="timetableViewOptions" v-model="selected" :reduce="label => label.code" :disabled="disabled" />

    </div>
</template>

<script>
import timetableview from '@/store/content/timetableview'
import vSelect from 'vue-select'
import utils from '@/plugins/TravellerUtils.js'

export default {
    components: {
        vSelect
    },
    data() {
        return {
            selected: this.value
        }
    },
    props: {
        value: String,
        disabled: {type: Boolean, default: false}
    },
    created() {
        if( !this.$store.state.timetableview ) {
            this.$store.registerModule("timetableview" , timetableview )
        }
    },
    mounted() {
        this.$store.dispatch('timetableview/list')
    },
    watch: {
        
        selected: function(newValue) {
            this.$emit('input' , newValue )
        },
        value: function(newVal, oldVal){
            if(newVal != oldVal)
                this.selected = newVal;

           //alert(this.value+"/"+this.selected)
        }

    },
    computed: {
        timetableviews: function() {
            return this.$store.state.timetableview.views
        },
        timetableViewOptions: function() {
            return this.timetableviews.map( view => {
                return { code: view.id, label: view.id + " - " + view.name }
            }).sort( ( a,b ) => {
                return utils.alfaNumericCompare(a.code,b.code)
            })
        }
    }
}
</script>
